// export const defaultrodHolderPositions = [ 0,-0.008,0.267 ] as const;
// export const defaultrodHolderPositions = [ 0,0,0 ] as const;

import { wardrobeItem } from '@/Interfaces/common';

export const defaultRodHolderRotation = [ 90,0,90 ] as const;

//TODO childPosition нет в админке
export const rodHolder = {
    uuid: crypto.randomUUID(),
    name: 'grb',
    height: 0.1,
    width: 0.1,
    depth: 0.1,
    childPosition: [ 0,-0.081,0 ],
    offsets: [ 0,0,0 ],
    rotation: defaultRodHolderRotation,
} as wardrobeItem;

